import React, { useEffect } from 'react';
import { RoutingPage, setPage } from '../../routes/routerSlice';
import ChangePassword from './ChangePassword/ChangePassword';
import { useAppDispatch } from '../../store';

const UserSettings: React.FC = () => {
  const dispatch = useAppDispatch();

  useEffect(() => {
    dispatch(setPage(RoutingPage.USER_SETTINGS));
  }, [dispatch]);

  return <ChangePassword />;
};

export default UserSettings;
